module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/2-acquire.json
// module id = 332
// module chunks = 142985079614491